import type { NodeDefinition } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertySchema } from './propertySchema'
import { z } from 'zod'

export const nodeDefinitionSchema = z.object({
  id: z.string().regex(/^[^:]+:[^:]+$/),
  color: z.string(),
  text_color: z.string().optional(),
  label: z.string(),
  description: z.string(),
  image_src: z.string().optional(),
  category: z.enum(['integration', 'transformation', 'flow', 'core', 'trigger', 'internal']),
  properties: z.array(z.lazy(() => propertySchema)).optional(),
  default_properties_values: z.object({}).catchall(z.any()).optional(),
}) as unknown as ToZod<NodeDefinition>

export type NodeDefinitionSchema = NodeDefinition